import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues } from '../../public/utility/formValues'

class StandardGuidelineDiv extends React.Component {
    state = {
        id: this.props.id,
        StandardInspectionID: this.props.StandardInspectionID,
        processing: 0,//限制并发操作
        onlyView: this.props.onlyView,
    }
    componentDidMount = () => {
        const { onClose, id, StandardInspectionID } = this.props
        Tyan.doPostEvent({
            event: 'GetStandardGuideline',
            data: { id, StandardInspectionID },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    onClose && onClose()
                }
                else {
                    this.setState({ id, optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
                setTimeout(this.handelFinish, 100)
            }
        })
    }

    handelBegin = () => this.setState((state) => ({ processing: state.processing + 1 }))
    handelFinish = () => this.setState((state) => ({ processing: state.processing - 1 }))

    handlerConfirm = () => {
        const { initValues基本信息, changedValues基本信息, id, StandardInspectionID } = this.state
        const { onSave, onClose } = this.props
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        if (!values.名称 || values.名称.trim() == '') { Ext.toast("名称不能为空！"); return }

        Tyan.doPostEvent({
            event: 'SaveStandardGuideline',
            data: { id, StandardInspectionID, changedValues基本信息 },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage }) => {
                setTimeout(this.handelFinish, 100)
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DelStandardGuideline',
                data: { id },
                onRequest: this.handelBegin,
                onEnd: ({ errorMessage }) => {
                    setTimeout(this.handelFinish, 100)
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => {
            onClose && onClose()
        })
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }

        return [
            { _text: '名称', required: true, minWidth: '90%' },
            { _text: '显示名称', minWidth: '90%' },
            { _text: '英文名称', minWidth: '90%' },
            { _text: '限值', minWidth: '90%' },
            { _text: '检出限', minWidth: '90%' },
            { _text: '单位', minWidth: '45%' },
            { _text: '英文单位', minWidth: '45%' },
            { _int: '排序', minWidth: '90%', textAlign: 'left' },
        ]
    }

    canSave = () => {
        const { changedValues基本信息 } = this.state
        return Object.keys(changedValues基本信息).length > 0
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息, onlyView } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        return <Body data={this} maxWidth="800"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave, cdt: () => !onlyView },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && !onlyView, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: onlyView },
                ]}
        />
    }
}

export default connect()(StandardGuidelineDiv)